<template>
  <div class="tutorials-topic-list">
    <p
      v-if="category?.subtitle"
      class="tutorials-topic-list__subtitle"
    >
      {{ category.subtitle }}
    </p>
    <p class="tutorials-topic-list__section-label">Topics</p>
    <ul class="tutorials-topic-list__items">
      <TutorialsListRow
        v-for="topic in topics"
        :key="topic.id"
        :name="topic.name"
        :secondary-text="topic.description"
        :disabled="!topic.isAvailable"
        :data-cy="`tutorials-topic-${topic.id}`"
        @click="emit('select-topic', topic.id)"
      />
    </ul>
  </div>
</template>

<script setup>
import {
  onboardingCategories,
  onboardingTopicContentTypes,
  onboardingWalkthroughs,
} from '@/constants/onboardingChecklist';

const props = defineProps({
  categoryId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['select-topic']);

const category = computed(() =>
  onboardingCategories.find((candidate) => candidate.id === props.categoryId),
);

const titleCase = (slug) =>
  slug
    .split('-')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');

// isAvailable checks content type, not whether text exists — managing-users already
// has a name/description but is still 'static-modal', so it stays disabled.
const topics = computed(() =>
  (category.value?.topicIds ?? []).map((topicId) => {
    const walkthrough = onboardingWalkthroughs.find((candidate) => candidate.id === topicId);
    const isAvailable = onboardingTopicContentTypes[topicId] === 'walkthrough';

    return {
      id: topicId,
      name: walkthrough?.name ?? titleCase(topicId),
      description: walkthrough?.description ?? '',
      isAvailable,
    };
  }),
);
</script>

<style lang="scss" scoped>
.tutorials-topic-list {
  &__subtitle {
    @apply tw-m-0 tw-px-4 tw-py-6 tw-text-base tw-font-regular tw-text-black-500;
  }

  &__section-label {
    @apply tw-m-0 tw-px-4 tw-pb-2 tw-text-sm tw-font-regular tw-text-text-link-on-light;
  }

  &__items {
    @apply tw-m-0 tw-list-none tw-p-0;
  }
}
</style>
